// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__5+EXm","link":"Logo_link__qu70O","image":"Logo_image__kVIiW"};